<div class="exercise-description">
    <rich-text [content]="content" customVideoPlayer customVideoPlayerObserve=".rich-text"></rich-text>
</div>
